module.exports = __webpack_public_path__ + "static/media/7.question.77b8e2aa.mp4";